/**
 * Alineado con backend memberValidatePasswordPolicy (PHP).
 */
const SPECIAL_CHARS = '!@#$%^&*()_+-=[]{}|;:,.<>?/~`/';

function hasSpecialChar(p) {
  for (let i = 0; i < p.length; i += 1) {
    if (SPECIAL_CHARS.includes(p[i])) return true;
  }
  return false;
}

export function validateMemberPassword(password) {
  const p = password || '';
  const rules = {
    length: p.length >= 8 && p.length <= 128,
    lower: /[a-z]/.test(p),
    upper: /[A-Z]/.test(p),
    digit: /[0-9]/.test(p),
    special: hasSpecialChar(p)
  };
  const ok = Object.values(rules).every(Boolean);
  return { ok, rules };
}
